import { isDemoMode, spoofText } from '@/utils/demoSpoof';

export const TOKENS_CSS = `:root {
  --ink:#1A1A2E; --body:#3C4257; --muted:#6B7280; --faint:#8A8FA0;
  --paper:#FAF9F6; --card:#FFFFFF; --hairline:#F0EFEC;
  --neutral-rail:#DAD8D2; --neutral-panel:#F5F4F1;
  --accent:#EF6C3B; --link:#C25326;
  --risk:#C0392B; --risk-tint:#FBEAE6;
  --attention:#B08A3A; --attention-tint:#FBF1E1;
  --stable:#2F6B49; --stable-tint:#E9F3ED;
  --info:#3E5C8A; --info-tint:#EEF1F7; --snf:#7A5EA8;
}`;

export const FRAME_CSP = "default-src 'none'; style-src 'unsafe-inline'; img-src data:; script-src 'unsafe-inline' https://cdnjs.cloudflare.com;";

export function demoSafeRows(rows) {
  if (!isDemoMode()) return rows || [];
  return (rows || []).map((row) => {
    const out = {};
    Object.keys(row || {}).forEach((key) => {
      const value = row[key];
      out[key] = typeof value === 'string' && value.length > 1 && Number.isNaN(Number(value)) ? spoofText(value) : value;
    });
    return out;
  });
}

export function demoSafeInputs(inputs) {
  const out = {};
  Object.keys(inputs || {}).forEach((name) => { out[name] = demoSafeRows(inputs[name]); });
  return out;
}

export function jsonForScript(value) {
  return JSON.stringify(value === undefined ? null : value).replace(/</g, '\\u003c');
}
